import { Instagram, Music2, Youtube } from "lucide-react";
import { JawaWordmark } from "./Logo";
import { ImpactStats } from "./ImpactStats";
import { CONTACT, SOCIALS, waLink } from "@/data/content";

const COLUMNS = [
  {
    title: "Explore",
    links: [
      { label: "Find Your Path", href: "/#journeys" },
      { label: "Destinations", href: "/destinations" },
      { label: "Experiences", href: "/#experiences" },
      { label: "Testimonials", href: "/testimonials" },
    ],
  },
  {
    title: "JÀWÀ",
    links: [
      { label: "A–Z Guides", href: "/guides" },
      { label: "Services", href: "/services" },
      { label: "Membership", href: "/members" },
      { label: "FAQ", href: "/faq" },
      { label: "Community", href: "/#community" },
      { label: "Your Downloads", href: "/orders" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-jawa-ivory/10 bg-jawa-nearblack">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <JawaWordmark />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-jawa-ivory/50">
            Come Back. Discover Africa Differently. JÀWÀ is a premium lifestyle, travel,
            relocation and investment platform for Africa — beginning with Nigeria.
          </p>
          <div className="mt-6 space-y-2 text-sm text-jawa-ivory/60">
            <p>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="transition-colors hover:text-jawa-ivory">
                {CONTACT.email}
              </a>
            </p>
            <p>
              <a href={waLink("Hello JÀWÀ!")} target="_blank" rel="noopener noreferrer" data-testid="footer-phone" className="transition-colors hover:text-jawa-ivory">
                WhatsApp {CONTACT.phoneDisplay}
              </a>
            </p>
            <div className="flex items-center gap-4 pt-2">
              <a href={SOCIALS.youtube} target="_blank" rel="noopener noreferrer" aria-label="JÀWÀ Africa on YouTube" data-testid="footer-social-youtube" className="text-jawa-ivory/50 transition-colors hover:text-jawa-coral">
                <Youtube className="h-5 w-5" />
              </a>
              <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" aria-label="JÀWÀ Africa on Instagram" data-testid="footer-social-instagram" className="text-jawa-ivory/50 transition-colors hover:text-jawa-coral">
                <Instagram className="h-5 w-5" />
              </a>
              <a href={SOCIALS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="JÀWÀ Africa on TikTok" data-testid="footer-social-tiktok" className="text-jawa-ivory/50 transition-colors hover:text-jawa-coral">
                <Music2 className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.title} className="lg:col-span-2">
            <p className="text-[10px] uppercase tracking-[0.3em] text-jawa-gold">{col.title}</p>
            <ul className="mt-5 space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-jawa-ivory/60 transition-colors hover:text-jawa-ivory"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div className="lg:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.3em] text-jawa-gold">Site</p>
          <ul className="mt-5 space-y-3">
            <li>
              <a href="/#concierge" data-testid="footer-link-concierge" className="text-sm text-jawa-ivory/60 transition-colors hover:text-jawa-ivory">
                Concierge & Enquiries
              </a>
            </li>
            <li>
              <a href="/emergency" data-testid="footer-link-emergency" className="text-sm text-jawa-ivory/60 transition-colors hover:text-jawa-ivory">
                Emergency Contacts
              </a>
            </li>
            <li>
              <a
                href="/admin/login"
                data-testid="footer-admin-link"
                className="text-sm text-jawa-ivory/60 transition-colors hover:text-jawa-ivory"
              >
                Owner Login
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-6 pb-0 lg:px-10">
        <ImpactStats variant="mini" />
      </div>
      <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-jawa-ivory/10 pt-8">
        <p className="text-xs text-jawa-ivory/40">© {new Date().getFullYear()} JÀWÀ AFRICA. All rights reserved.</p>
        <p className="text-xs text-jawa-ivory/30">Guides provide practical orientation, not regulated legal or financial advice.</p>
        <p className="mt-3 text-xs text-jawa-ivory/30">
          <a href="/legal" data-testid="footer-link-legal" className="underline transition-colors hover:text-jawa-ivory/60">Privacy, terms, cookies, payments & refunds</a>
        </p>
      </div>
    </div>
  </footer>
);
